<template>
  <div>
    <basic-container>
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
        @search-change="searchChange" @refresh-change="refreshChange(page)" @size-change="pageSizeChange"
        @current-change="pageChange">
        <template slot="menuLeft">
          <el-button type="text" icon="el-icon-download" size="mini" plain :loading="downloadLoading"
            @click.stop="downloadExcelWorkOrder">下载所有Excel</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button type="text" icon="el-icon-view" size="small" plain @click.stop="handleView(scope.row)">报单
          </el-button>
        </template>
        <template slot-scope="scope" slot="orderStatus">
          <div v-for="obj of orderStatusList" :key="obj.value">
            <el-tag v-if="obj.value == scope.row.orderStatus" :type="orderStatusType(obj.label)">
              {{ obj.label }}</el-tag>
          </div>
        </template>
      </avue-crud>
      <ViewDeclarationModal :visible.sync="viewDeclarationVisible" :id="currentDeclarationId"
        @close="handleDeclarationModalClose" />
    </basic-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { pipelineTestingTableOption } from "@/const/work/pipelineTesting/merchantsOption";
import {
  findPipelineTesting,
  downloadExcelPiplineTest,
} from "@/api/work/pipelineTesting";
import { getOrderStatusList } from "@/api/work/ceiling/merchants";
import { getAgentList } from "@/api/work/pipeline/merchants";
import ViewDeclarationModal from "./components/view-declaration-modal.vue";
export default {
  name: "pipelineTesting",
  components: {
    ViewDeclarationModal,
  },
  data() {
    return {
      tableOption: pipelineTestingTableOption,
      tableData: [],
      tableLoading: false,
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 30,
      },
      downloadData: {},
      downloadLoading: false,
      agentList: [],
      hasSetDefaultAgent: false,
      viewDeclarationVisible: false,
      currentDeclarationId: "",
      orderStatusList: [],
    };
  },
  created() {
    this.getAgentList();
    this.handleList();
    this.getOrderStatus();
  },
  watch: {
    agentList(newVal) {
      if (!this.hasSetDefaultAgent && Array.isArray(newVal) && newVal.length) {
        const first = newVal[0];
        this.$nextTick(() => {
          if (this.$refs && this.$refs.crud && this.$refs.crud.searchForm) {
            if (!this.$refs.crud.searchForm.rootDepartId) {
              this.$set(this.$refs.crud.searchForm, "rootDepartId", first.value);
              this.hasSetDefaultAgent = true;
              this.searchChange({ ...this.$refs.crud.searchForm });
            }
          }
        });
      }
    },
  },
  computed: {
    ...mapGetters(["permission"]),
  },
  methods: {
    orderStatusType(label) {
      if (label == "已完成") {
        return "success";
      } else if (label == "服务中") {
        return "primary";
      } else if (label == "已作废") {
        return "danger";
      } else {
        return "warning";
      }
    },
    async getOrderStatus() {
      try {
        const res = await getOrderStatusList("type=water_proof_declaration");
        if (res.code == "200") {
          this.orderStatusList = JSON.parse(res.data);
          this.orderStatusList = this.orderStatusList.map((item) => ({
            label: item.name,
            value: item.code,
          }));
          const idx = Array.isArray(this.tableOption.column)
            ? this.tableOption.column.findIndex(
              (col) => col && col.prop === "orderStatus"
            )
            : -1;
          if (idx !== -1) {
            this.$set(
              this.tableOption.column[idx],
              "dicData",
              this.orderStatusList
            );
          }
        }
      } catch (error) {
        this.$message.error("获取订单状态失败");
      }
    },
    async getAgentList() {
      const res = await getAgentList();
      if (res.code == "200") {
        this.agentList = JSON.parse(res.data);
        this.agentList = this.agentList.map((item) => ({
          ...item,
          label: item.company,
          value: item.id,
        }));
        const idx = Array.isArray(this.tableOption.column)
          ? this.tableOption.column.findIndex(
            (col) => col && col.prop === "rootDepartId"
          )
          : -1;
        if (idx !== -1) {
          this.$set(this.tableOption.column[idx], "dicData", this.agentList);
        }
      }
    },
    handleView(row) {
      this.currentDeclarationId = row.id;
      this.viewDeclarationVisible = true;
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = pageSize;
      findPipelineTesting(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize,
        };
      }).catch((err) => {
        this.$message.error("查询失败：" + (err && err.message ? err.message : "未知错误"));
      }).finally(() => {
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      findPipelineTesting(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize,
        };
      }).catch((err) => {
        this.$message.error("查询失败：" + (err && err.message ? err.message : "未知错误"));
      }).finally(() => {
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      this.downloadData = params;
      findPipelineTesting(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size,
        };
      }).catch((err) => {
        this.$message.error("查询失败：" + (err && err.message ? err.message : "未知错误"));
      }).finally(() => {
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      findPipelineTesting(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize,
        };
      }).catch((err) => {
        this.$message.error("查询失败：" + (err && err.message ? err.message : "未知错误"));
      }).finally(() => {
        this.tableLoading = false;
      });
    },
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize,
      };
      this.downloadData = parmas;
      findPipelineTesting(parmas).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
      }).catch((err) => {
        this.$message.error("查询失败：" + (err && err.message ? err.message : "未知错误"));
      }).finally(() => {
        this.tableLoading = false;
      });
    },
    // 工具：把秒级/毫秒级时间戳统一转成毫秒（<=10 位视为秒级）
    toMillis(t) {
      if (t === undefined || t === null || t === "") return undefined;
      const n = Number(t);
      if (Number.isNaN(n)) return undefined;
      return String(n).length <= 10 ? n * 1000 : n;
    },
    downloadExcelWorkOrder() {
      
      this.tableLoading = false;
      if (this.downloadLoading) return;
      this.downloadLoading = true;
      const src = this.downloadData || {};
      const params = {};
      if (src.shopId) params.shopId = src.shopId;
      const startMs = this.toMillis(src.timeStart);
      const endMs = this.toMillis(src.timeEnd);
      if (startMs !== undefined) params.startTime = startMs;
      if (endMs !== undefined) params.endTime = endMs;
      const finish = () => {
        this.downloadLoading = false;
      };
      downloadExcelPiplineTest(params)
        .then((response) => {
          this.tableLoading = false;
          const disposition =
            (response.headers && response.headers["content-disposition"]) || "";
          const match = disposition.match(/filename=(.*)/);
          const rawName = match ? match[1] : "管道试压预约单.xlsx";
          const filename = decodeURI(rawName);
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          if (typeof window.navigator.msSaveBlob !== "undefined") {
            window.navigator.msSaveBlob(blob, filename);
          } else {
            const blobURL = window.URL.createObjectURL(blob);
            const tempLink = document.createElement("a");
            tempLink.style.display = "none";
            tempLink.href = blobURL;
            tempLink.setAttribute("download", filename);
            if (typeof tempLink.download === "undefined") {
              tempLink.setAttribute("target", "_blank");
            }
            document.body.appendChild(tempLink);
            tempLink.click();
            document.body.removeChild(tempLink);
            window.URL.revokeObjectURL(blobURL);
            this.downloadLoading = false;
          }
        })
        .catch((err) => {
          this.$message.error("下载失败：" + (err && err.message ? err.message : "未知错误"));
          this.tableLoading = false;
          this.downloadLoading = false;
        })
        .finally(finish);
    },
    handleDeclarationModalClose() {
      this.currentDeclarationId = "";
    },
  },
};
</script>
